import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BigIconTextComponent } from '../../../shared/components/big-icon-text/big-icon-text.component';
import { RouterLink } from '@angular/router';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';

@Component({
  selector: 'pt-registersuccess',
  templateUrl: './registersuccess.component.html',
  styleUrls: ['./registersuccess.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BigIconTextComponent, RouterLink, Bind, Button],
})
export class RegistersuccessComponent {}
